/* Prospera Biotech — interacciones (vanilla JS) */
(function () {
  'use strict';

  /* ---- Announce bar: ticker rotativo ---- */
  const announce = document.querySelector('[data-announce]');
  if (announce) {
    const msgs = Array.from(announce.querySelectorAll('[data-announce-msg]'));
    if (msgs.length > 1) {
      let idx = msgs.findIndex(m => m.classList.contains('is-active'));
      if (idx < 0) idx = 0;
      let timer;
      const show = (i) => {
        msgs[idx].classList.remove('is-active');
        idx = (i + msgs.length) % msgs.length;
        msgs[idx].classList.add('is-active');
      };
      const restart = () => { clearInterval(timer); timer = setInterval(() => show(idx + 1), 4500); };
      announce.querySelector('[data-announce-prev]').addEventListener('click', () => { show(idx - 1); restart(); });
      announce.querySelector('[data-announce-next]').addEventListener('click', () => { show(idx + 1); restart(); });
      restart();
    }
  }

  /* ---- Menú móvil ---- */
  const burger = document.querySelector('[data-burger]');
  const mnav = document.querySelector('[data-mobile-nav]');
  const mnavClose = document.querySelector('[data-mobile-nav-close]');
  if (burger && mnav) {
    burger.addEventListener('click', () => mnav.classList.add('is-open'));
    if (mnavClose) mnavClose.addEventListener('click', () => mnav.classList.remove('is-open'));
    mnav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => mnav.classList.remove('is-open')));
  }

  /* ---- Carruseles (rail prev/next) ---- */
  document.querySelectorAll('[data-rail]').forEach(rail => {
    const track = rail.querySelector('[data-rail-track]');
    const step = () => Math.min(track.clientWidth * 0.9, 640);
    rail.querySelectorAll('[data-rail-prev]').forEach(b => b.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' })));
    rail.querySelectorAll('[data-rail-next]').forEach(b => b.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' })));
  });

  /* ---- Acordeones (secciones PDP) ---- */
  document.querySelectorAll('[data-accordion] > .accordion__head').forEach(head => {
    head.addEventListener('click', () => head.parentElement.classList.toggle('is-open'));
  });

  /* ---- FAQ interno ---- */
  document.querySelectorAll('[data-faq] > .faq__head').forEach(head => {
    head.addEventListener('click', () => head.parentElement.classList.toggle('is-open'));
  });

  /* ---- Galería PDP: cambio de thumbnail ---- */
  const thumbs = document.querySelectorAll('[data-thumb]');
  const frames = document.querySelectorAll('[data-frame]');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const idx = thumb.getAttribute('data-thumb');
      thumbs.forEach(t => t.classList.toggle('is-active', t.getAttribute('data-thumb') === idx));
      frames.forEach(f => {
        const isActive = f.getAttribute('data-frame') === idx;
        f.classList.toggle('is-active', isActive);
        if (!isActive) { f.querySelectorAll('video').forEach(v => v.pause()); }
      });
    });
  });

  /* ---- Selector de formato + precio ---- */
  const priceEls = document.querySelectorAll('[data-price]');
  document.querySelectorAll('[data-format]').forEach(opt => {
    opt.addEventListener('click', () => {
      document.querySelectorAll('[data-format]').forEach(o => o.classList.remove('is-active'));
      opt.classList.add('is-active');
      const price = opt.getAttribute('data-price-value');
      priceEls.forEach(p => { p.textContent = price; });
    });
  });

  /* ---- Stepper de cantidad (sincroniza input oculto del form) ---- */
  document.querySelectorAll('[data-qty]').forEach(box => {
    const val = box.querySelector('[data-qty-val]');
    const scope = box.closest('form') || box.parentElement;
    const input = scope ? scope.querySelector('[data-qty-input]') : null;
    const sync = () => { if (input) input.value = val.textContent; };
    box.querySelector('[data-qty-minus]').addEventListener('click', () => {
      val.textContent = Math.max(1, parseInt(val.textContent, 10) - 1); sync();
    });
    box.querySelector('[data-qty-plus]').addEventListener('click', () => {
      val.textContent = parseInt(val.textContent, 10) + 1; sync();
    });
  });

  /* ---- Filtros de reseñas (solo estado visual) ---- */
  document.querySelectorAll('[data-review-chip]').forEach(chip => {
    chip.addEventListener('click', () => {
      document.querySelectorAll('[data-review-chip]').forEach(c => c.classList.remove('is-active'));
      chip.classList.add('is-active');
    });
  });
})();
